import React from 'react';
import { FaSpinner } from 'react-icons/fa'; // Aapki icon library se
import './../assets/css/Loading.css';

const FullScreenLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <FaSpinner className="spinner-icon" />
      </div>
    </div>
  );
};

export default FullScreenLoader;